import React, { ReactNode, useCallback, useEffect } from 'react';

import { NavigateOptions, To, useLocation, useNavigate, useParams } from 'react-router-dom';

import { RouterContext } from './routerExports';

interface RouterProviderProps {
  children: ReactNode;
}

type NavigationArgs = [To, NavigateOptions?];

export const RouterProvider: React.FC<RouterProviderProps> = ({ children }) => {
  // Always use the hooks from react-router-dom since RouterProvider is now guaranteed to be inside BrowserRouter
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const handleNavigation = useCallback(
    (args: NavigationArgs) => {
      try {
        navigate(...args);
      } catch (error) {
        console.error('Error al procesar navegación:', error);
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (window.__pendingNavigations?.length) {
      const navigations = [...window.__pendingNavigations];
      window.__pendingNavigations = [];
      navigations.forEach(handleNavigation);
    }
  }, [handleNavigation]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (window.__pendingNavigations?.length) {
        e.preventDefault();
        return (e.returnValue = '');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return (
    <RouterContext.Provider value={{ navigate, location, params }}>
      <div data-router-initialized="true" style={{ display: 'none' }} />
      {children}
    </RouterContext.Provider>
  );
};
